<mat-form-field [class]="inputClass" [subscriptSizing]="subscriptSizing" [appearance]="inputAppearance">
    <mat-label>{{ placeholder }}</mat-label>
    <input #itemsListInput matInput type="text" [matAutocomplete]="itemsList" [value]="value" (blur)="clearText($event)"
        [attr.data-qa-id]="dataQaId">
    @if (!hideArrow) {
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    }
    <mat-autocomplete #itemsList="matAutocomplete" [displayWith]="displayFn" hideSingleSelectionIndicator="false" (optionSelected)="selectedItem($event)">
        @for (item of items; track item) {
        <mat-option [value]="item">
            {{ displayItem(item) }}
        </mat-option>
        }
    </mat-autocomplete>
    @if (!loading && icon) {
    <mat-icon matSuffix>{{icon}}</mat-icon>
    }
    @if (loading) {
    <mat-progress-spinner matSuffix mode="indeterminate" strokeWidth="2" diameter="24">
    </mat-progress-spinner>
    }
</mat-form-field>